import { graphClient } from '../../../graph-client'
import { GET_USERS_TASKS_SPECTATORS_DEFAULTS } from './gql'
import type { GetList } from './types'

class UserTaskSpectatorDefaultService {
  async getList({ take = 20, skip = 0, ...params }: GetList.Input) {
    const request = await graphClient.request<GetList.Output>(
      GET_USERS_TASKS_SPECTATORS_DEFAULTS,
      { ...params, take, skip: take * skip },
    )

    return request?.getUsersTasksSpectatorsDefaults
  }
}

export const userTaskSpectatorDefaultService =
  new UserTaskSpectatorDefaultService()
